import styled from "@emotion/styled";
import Colors from "/styles/colors";
import { BRAND_BLACK_TEXT_COLOR, BRAND_LIGHT_COLOR_NAME } from "styles/color-consts";
import { TABLET_QUERY_MAX_WIDTH, MACBOOK_PRO_MAX_WIDTH, SM, MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";
import { TOP_LAYER } from "constants/z-index";
const TEXT_COLOR = "#d6ccff";
const PHONE_TEXT_COLOR = "#727b9a";
const BORDER_COLOR = "#dcdfec";
export const StyledHubspotOnDarkBackgroundFormComponent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
  flex-direction: column;
  .side-by-side-text-and-asset .side-by-side-content {
    display: flex;
    justify-content: space-between;
    gap: 80px;
    .full-paragraph-component-wrapper {
      height: 100%;
      display: flex;
      padding: 0;

      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: left;
        height: 100%;

        .top-part {
          .title-wrapper .core-title {
            margin-bottom: 48px;
            font-size: 2.75rem;
            font-weight: 600;
            line-height: 48px;
          }

          .values-list-wrapper {
            display: flex;
            flex-direction: column;
            gap: 20px;
            .value-item {
              display: flex;
              line-height: 24px;
              gap: 12px;
              font-size: 1rem;
              text-align: left;
              .vi-icon .picture-component {
                display: flex;
                height: 20px;
              }
            }
          }
          .seperator-line {
            width: 430px;
            height: 1px;
            background-color: ${BORDER_COLOR};
            margin: 32px 0;
          }
        }

        .bottom-part {
          .customer-quote-wrapper {
            background-color: ${Colors[BRAND_LIGHT_COLOR_NAME]};
            border-radius: 8px;
            padding: 24px 32px;
            margin-bottom: 32px;
            width: 600px;

            .quote {
              position: relative;
              margin: auto 0;
              display: flex;
              text-align: left;
              letter-spacing: -0.5px;
              line-height: 30px;
              font-size: 1.125rem;

              .quotationMark {
                position: absolute;
                top: 0;
                left: -12px;
                margin-right: 8px;
              }
            }

            .costumer-details {
              display: flex;
              margin-top: 32px;
              gap: 16px;
              .face-picture {
                .picture-component {
                  img {
                    width: 48px;
                  }
                }
              }

              .name-and-job-description {
                line-height: 25px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                .name {
                  font-size: 0.875rem;
                  font-weight: 600;
                  line-height: 20px;
                }
                .job-description {
                  line-height: 20px;
                  font-size: 0.875rem;
                }
              }
            }
          }
        }
      }
    }

    .image-wrapper {
      overflow: unset;
      .form-wrapper {
        .hubspot-contact-form-wrapper .base-form {
          width: 460px;
          margin: 0;
          padding: 32px;
          border: 1px solid ${BORDER_COLOR};
          box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.06);
          .form-title-wrapper {
            color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
            text-align: center;
            .monday-markup-language-component {
              font-weight: 600;
              font-size: 1rem;
            }
          }
          .contact-form-row {
            margin-bottom: 12px;
            .form-input-wrapper {
              .required-error {
                font-size: 0.7875rem;
              }
              padding: 0 5px 0 5px;
              .generic-form-input-component {
                .form-input-wrapper {
                  margin-bottom: 10px;
                  padding: 0;
                  .hp-input {
                    height: 46px;
                    border-radius: 6px;
                    &.hp-textarea-input {
                      height: 80px;
                    }
                    &.hp-phone-input {
                      .react-tel-input {
                        height: 46px;
                        input {
                          height: 46px;
                        }
                        .flag-dropdown {
                          .country-list {
                            color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
                          }
                        }
                      }
                      .react-tel-input::before {
                        content: "*";
                        position: absolute;
                        top: 4px;
                        left: 44px;
                        color: ${PHONE_TEXT_COLOR};
                        z-index: ${TOP_LAYER};
                        font-family: Poppins;
                      }
                    }
                  }
                  .hp-multi-select-input {
                    .react-select__control {
                      min-height: 46px;
                      border-radius: 6px;
                      text-align: left;
                      .react-select__value-container {
                          min-height: 44px;
                      }
                    }
                  }

                  .react-select__menu {
                    z-index: ${TOP_LAYER};
                  }
                }
              }
            }
          }

          .privacy-notice-wrapper .privacy-notice {
            color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
            margin-top: 24px;
          }
        }
      }
    }
  }

  .logos-wrapper {
    display: flex;
    flex-direction: column;
    width: 640px;
    .logos {
      display: flex;
      flext-direction: row;
      width: 600px;
      gap: 42px;
      justify-content: center;
      .logo-wrapper {
        .picture-component {
          img {
            height: 30px;
          }
        }
      }
    }
  }
    
  @media (max-width: ${MACBOOK_PRO_MAX_WIDTH}) {
    .side-by-side-text-and-asset .side-by-side-content {
      gap: 32px;
      .full-paragraph-component-wrapper .content {
        max-width: 540px;
        .top-part {
          .title-section .title-wrapper .core-title {
            font-size: 2.25rem;
          }
        }
        .bottom-part {
          .customer-quote-wrapper {
            width: 500px;
          }
          .logos-wrapper .logos {
            width: 500px;
            gap: 36px;
            .logo-wrapper .picture-component img {
              height: 24px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1110px) and (min-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .side-by-side-text-and-asset .side-by-side-content {
      .full-paragraph-component-wrapper {
        .content {
          .bottom-part {
            .customer-quote-wrapper {
              width: 100%;
              max-width: 600px;
              box-sizing: border-box;
            }
            .logos-wrapper {
              width: 100%;
              max-width: 640px;
              box-sizing: border-box;
              .logos {
                width: 100%;
                max-width: 600px;
                box-sizing: border-box;
              }
            }
          }
        }
      }
    }
  }
    
  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
      .side-by-side-text-and-asset .side-by-side-content {
        .full-paragraph-component-wrapper {
          .content {
            .top-part {
              .title-section {
                .title-wrapper .core-title {
                    text-align: left;
                    font-size: 1.5rem;
                    line-height: 32px;
                }
              }
            }
            .bottom-part {
              padding-top: 32px;
            }
          }
        }
        .image-wrapper {
          .form-wrapper {
            .hubspot-contact-form-wrapper .base-form {
              width: 560px;
              .form-title-wrapper {
                .monday-markup-language-component  {
                    font-size: 1.5rem;
                }
              }
              .contact-form-row {
                margin-bottom: 0;
                .form-input-wrapper {
                    margin-bottom: 22px;
                }
              }
            }
          }
        }
      }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    &.hubspot-on-dark-background-form-component {
      padding: 0 16px;
    }
    .side-by-side-text-and-asset .side-by-side-content {
      .full-paragraph-component-wrapper {
        width: 100%;
        padding: 0;
        .content {
          text-align: center;
          .top-part {
            padding: 0 16px;
            .seperator-line {
              width: 100%;
            }
          }
          .bottom-part {
            .customer-quote-wrapper {
              width: 100%;
              padding: 32px;
              .quoteText{
                text-align: center;
              }
              .costumer-details {
                flex-direction: column;
                align-items: center;
                gap: 8px;
                .name-and-job-description {
                  align-items: center;
                }
              }
            }
            .logos-wrapper {
              width: 100%;
              max-width: 100vw;
              .logos {
                width: 100%;
                gap: 16px;
                flex-wrap: wrap;
                justify-content: center;
              }
            }
          }
        }
      }
      .image-wrapper {
          padding: 0 !important;
        .form-wrapper {
          .hubspot-contact-form-wrapper .base-form {
            width: 100%;
            min-width: 0;
            padding: 32px;
            box-shadow: none;
            .form-title-wrapper {
              .monday-markup-language-component {
                font-size: 1.5rem;
              }
            }
          }
        }
      }
    }
  }
`;
